module.exports = __webpack_public_path__ + "img/lobster-blue.e5842304.svg";